import React from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/index.css";
import App from "./components/App/App";
import { Provider } from "react-redux";
import Store from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from 'redux-persist'
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

// Read server-provided data (if SSR)
const initialData = typeof window !== 'undefined' ? window.__INITIAL_DATA__ : undefined;
const isSSR = !!initialData; // Check if server-rendered

if (typeof window !== 'undefined' && window.__INITIAL_DATA__) {
  delete window.__INITIAL_DATA__;
}

let persistor = persistStore(Store);

// Hydrate instead of render (supports both SSR and CSR)
// Skip PersistGate during SSR hydration to prevent mismatch
hydrateRoot(
  document.getElementById("root"),
  <Provider store={Store}>
    {isSSR ? (
      // SSR path: No PersistGate to match server render
      <BrowserRouter>
        <App initialData={initialData} />
      </BrowserRouter>
    ) : (
      // CSR path: Include PersistGate for localStorage sync
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App initialData={initialData} />
        </BrowserRouter>
      </PersistGate>
    )}
  </Provider>
);
